import {
  InstantUploadLogoField,
  InstantUploadLogoFieldProps,
} from '@components/logo-field/logo-field';

import { FormFieldProps } from './types';
import { useFormField } from './use-form-field';

export type FormInstantUploadLogoFieldProps<T> = FormFieldProps<InstantUploadLogoFieldProps, T>;

export function FormInstantUploadLogoField<T>(props: FormInstantUploadLogoFieldProps<T>) {
  const formFieldProps = useFormField(props);

  return <InstantUploadLogoField {...props} {...formFieldProps} />;
}
